<template>
  <div class="container">
    <div class="wrap">
      <div class="page-t">购买修图包</div>
      <div class="list-con">
        <el-row :gutter="20">
          <el-col :span="6" v-for="(item,index) in list" :key="index">
            <psItem :itemData="item"></psItem>
          </el-col>
        </el-row>
        <!-- 结果为空 -->
        <el-empty class="empty-con" description="暂无数据" :image-size="180" v-if="list.length == 0">
          <img class="img" src="../assets/images/default-list.png" slot="image"/>
        </el-empty>
        <!-- 分页 -->
        <el-pagination 
          class="pagination" 
          background 
          layout="prev, pager, next" 
          :total="totalNum"
          :page-size="pageSize"
          hide-on-single-page
          @current-change="changePage"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import psItem from '@/components/item/psItem';
export default {
  components: {
    psItem,
  },
  data() {
    return {
      curPage:1,
      totalNum:0,
      pageSize:20,
      list:[],
    };
  },
  computed: {
    
  },
  mounted() {
    this.getRows();
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    //分页
    changePage(e){
      this.curPage = e;
      this.getRows();
    },
    getRows(){
      let offset = (this.curPage-1)*this.pageSize;
      this.$axios.api.psList({
        offset: offset,
        length: this.pageSize,
        object: 'prize',
      }, (res) => {
        this.list = res.data.list;
        this.totalNum = res.data.total;
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.wrap{
  align-items: flex-start;
}
.list-con{
  
}
</style>
